/* eslint-disable no-param-reassign */
import 'firebase/auth';
import 'firebase/database';
import 'firebase/functions';
import 'firebase/firebase-storage';
import app from 'firebase/app';

const prodConfig = {
  apiKey: 'AIzaSyCUzjXzOtXchhbFgISc8pveTWGpGHCBoZM',
  authDomain: 'rf-lykkehjulet.firebaseapp.com',
  databaseURL: 'https://rf-lykkehjulet.firebaseio.com',
  projectId: 'rf-lykkehjulet',
  storageBucket: 'rf-lykkehjulet.appspot.com',
  messagingSenderId: '518073179777',
  appId: '1:518073179777:web:8c8ea6150b122ab77a7780',
  measurementId: 'G-JVNNHPK4N7'
};

const devConfig = {
  apiKey: 'AIzaSyAsNqn2DngmGio5uZyxSXUIZwQ5ijfT4uQ',
  authDomain: 'rf-lykkehjulet-test.firebaseapp.com',
  databaseURL: 'https://rf-lykkehjulet-test.firebaseio.com',
  projectId: 'rf-lykkehjulet-test',
  storageBucket: '"rf-lykkehjulet-test.appspot.com',
  messagingSenderId: '"925755457850',
  appId: '1:925755457850:web:daf2701ab750a668d01003',
  measurementId: 'G-2VQ2SZFZYR'
};

const devSondreConfig = {
  apiKey: 'AIzaSyCmvuQ675-Vkr80L9XuhR13HBPhoVisDmY',
  authDomain: 'solea-lykkehjulet-dev.firebaseapp.com',
  databaseURL: 'https://solea-lykkehjulet-dev.firebaseio.com/',
  projectId: 'solea-lykkehjulet-dev',
  storageBucket: 'solea-lykkehjulet-dev.firebasestorage.app',
  messagingSenderId: '743929159777',
  appId: '1:743929159777:web:f9e9cf4ffb6d0f36380a20'
};

const config = process.env.NODE_ENV === 'production' ? prodConfig : devSondreConfig;

class FirebaseClient {
  auth: app.auth.Auth;

  db: app.database.Database;

  storage: app.storage.Storage;

  functions: app.functions.Functions;

  constructor() {
    app.initializeApp(config);

    /* Firebase APIs */
    this.auth = app.auth();
    this.db = app.database();
    this.storage = app.storage();
    this.functions = app.functions();
  }
}

export default new FirebaseClient();
